import { render, staticRenderFns } from "./Step4Component.vue?vue&type=template&id=aecac7e6&scoped=true&"
import script from "./Step4Component.vue?vue&type=script&lang=js&"
export * from "./Step4Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecac7e6",
  null
  
)

export default component.exports